module.exports = __webpack_public_path__ + "posture/static/img/testxo.5f79f23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posturebodyview/testxo.jpg
// module id = nXJ6
// module chunks = 1